<template>
  <AppDialog
    class="members-update-dialog"
    data-testid="members-update-dialog"
    :title="title"
    append-to-body
    show
    @close="close"
  >
    <div
      v-if="resultHTML"
      v-html="resultHTML"
    ></div>
    <div v-else>
      <p>Your file is being processed in the background. This may take a few moments. You can stay here to see the results or get them via email if you close this dialog.</p>
    </div>

    <template #footer>
      <div>
        <div class="d-flex align-items-center">
          <a
            v-if="showUpload"
            class="nav-link"
            @click="skipToUpload"
          >
            Back to upload
          </a>
          <AppButton
            type="default ml-auto"
            @click="close"
          >
            Close
          </AppButton>
        </div>
      </div>
    </template>
  </AppDialog>
</template>

<script>
import FileImportChannel from '~/channels/file_import_channel';
import { FileImportsResource } from '~/resources';

export default {
  name: 'MembersUpdateProcessingDialog',
  props: {
    importId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      subscription: null,
      title: 'Processing...',
      resultHTML: null,
      showUpload: false,
      lastState: null,
    };
  },
  watch: {
    importId: {
      handler(newImportId) {
        if (newImportId) {
          this.resetState();
          this.subscribeToChannel();
          this.loadStatus();
        }
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    this.resetState();
  },
  methods: {
    resetState() {
      this.unsubscribeFromChannel();
      this.title = 'Processing...';
      this.resultHTML = null;
      this.showUpload = false;
      this.lastState = null;
    },
    skipToUpload() {
      this.$emit('skipToUpload');
    },
    async loadStatus() {
      const { status, title, html } = await FileImportsResource.fetch({ id: this.importId});
      const newState = `${status}.${this.importId}`;

      if (this.lastState === newState) {
        return;
      } // to not trigger $appMessage twice

      this.lastState = newState;

      switch (status) {
        case 'completed':
          this.$appMessage('Update completed successfully!');
          this.title = 'Completed!';
          this.resultHTML = '<p>Your import was completed successfully.</p>';
          break;
        case 'failed':
          this.$appMessage('File processing completed with errors.');
          this.title = title || 'Failed!';
          this.resultHTML = html;
          this.showUpload = true
          break;
      }
    },
    subscribeToChannel() {
      if (this.importId) {
        this.subscription = FileImportChannel.subscribe(this.importId, this.loadStatus.bind(this));
      }
    },
    unsubscribeFromChannel() {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }
    },
    close() {
      this.unsubscribeFromChannel();
      this.$emit('close');
    },
  },
};
</script>
